import React, { useState, useEffect } from "react";
import CardComponent from "../../components/CardComponent";
import { notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, resetCart } from "../../../toolkit/slices/cart/cartSlice";
import { removeCartInventory } from "../../../toolkit/slices/cart/cartSlice";
const CardContainer = ({ data, showModal }) => {
  const [cart, setCart] = useState([]);
  const [cartCodeNos, setCartCodeNos] = useState([]);
  const reduxCart = useSelector((state) => state.cartSpace.cart);
  const dispatch = useDispatch();
  notification.config({
    top: 60,
  });
  useEffect(() => {
    setCart(reduxCart);
    setCartCodeNos(reduxCart?.map((ele) => ele.CodeNo));
  }, [reduxCart]);
  function canAddToCart(it, cr) {
    if (cr.length > 0 && it) {
      let cart = cr.map((ele) => ele?.replace(/\s/g, ""));
      let item = it.replace(/\s/g, "");
      let mainGroup = item.split("-").slice(0, 2).join("-");
      let subGroups = item.split("-").slice(2);

      if (subGroups.length === 2) {
        // Item is of the form "YS-XX-A-B"
        let itemA = `${mainGroup}-${subGroups[0]}`;
        let itemB = `${mainGroup}-${subGroups[1]}`;
        if (cart.includes(itemA)) {
          return {
            canAdd: false,
            reason: `Cannot add ${item} because ${itemA} is already in the cart.`,
          };
        }
        if (cart.includes(itemB)) {
          return {
            canAdd: false,
            reason: `Cannot add ${item} because ${itemB} is already in the cart.`,
          };
        }
      } else if (subGroups.length === 1) {
        // Item is of the form "YS-XX-A"
        let itemA = subGroups[0];
        let combinedItems = cart.filter((cartItem) => {
          let cartMainGroup = cartItem.split("-").slice(0, 2).join("-");
          let cartSubGroups = cartItem.split("-").slice(2);
          return (
            cartMainGroup === mainGroup &&
            cartSubGroups.length === 2 &&
            (cartSubGroups[0] === itemA || cartSubGroups[1] === itemA)
          );
        });

        if (combinedItems.length > 0) {
          return {
            canAdd: false,
            reason: `Cannot add ${item} because ${combinedItems[0]} is already in the cart.`,
          };
        }
      }

      return { canAdd: true, reason: "" };
    } else {
      return { canAdd: true, reason: "" };
    }
  }

  function addItemToCart(item) {
    let itemIsPresent = cart.some((ele) => ele._id === item._id);
    // let result = canAddToCart(item.CodeNo,cartCodeNos);
    // if(!result?.canAdd && result.reason){
    //     notification.error({message:result.reason})
    // }
    if (!itemIsPresent) {
      console.log("add to cart needed info: ", item);
      dispatch(addToCart(item));
      notification.success({
        message: "Inventory added to the cart!",
        duration: 0.9,
      });
    }

    //Below is the original code

    //     let result = canAddToCart(item.CodeNo,cartCodeNos);
    //     if(!result?.canAdd && result.reason){
    //         notification.error({message:result.reason})
    //     }
    //     if (!itemIsPresent && result.canAdd) {
    //         console.log("add to cart needed info: ", item)
    //         dispatch(addToCart(item));
    //         notification.success({
    //             message: "Inventory added to the cart!",
    //             duration:.9
    //         });
    //     }
  }
  function removeFromCart(id) {
    dispatch(removeCartInventory(id));
    notification.error({
      message: "Inventory removed from cart!",
    });
  }

  return (
    <CardComponent
      item={data}
      showModal={showModal}
      addItemToCart={addItemToCart}
      itemIsPresent={cart.some((ele) => ele._id === data._id)}
      removeFromCart={removeFromCart}
    />
  );
};

export default CardContainer;
